import React, { useState, useEffect, useContext } from 'react'

import SiteAccessContext from '../../../contexts/SiteAccessContext';

import { useMsal } from '@azure/msal-react';
import { fetchDataAuthenticated } from '../../../utilities/HttpUtils';
import { usePrivileges } from '../../../hooks/usePrivileges';

import useAlert from '../../Alerts/useAlert';

import '../../DataGrid.css';
import gridLogo from "../../../Images/grid.svg";
import ILRMaterialMapForm from './ILRMaterialMapForm';

// Styling
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import * as ExcelJS from 'exceljs'

function ILRMaterialMapGrid(props) {

    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [Alertopen, AlertsetOpen] = React.useState(false);
    const [SelectedValue, setSelectedValue] = useState('');

    const { assignedSites } = useContext(SiteAccessContext);

    const { accounts } = useMsal();

    const username = accounts[0] && accounts[0].username;

    const { contributor } = usePrivileges();

    const { setAlert } = useAlert();

    const DeleteRow = (params) => {
        return (
            <strong>
                <button type="button" style={{ width: "80%" }} className="btn btn-outline-primary btn-sm" 
                    disabled= {!contributor ? true : params.row.active ? true : false}
                onClick={() => {
                    ActivateOrInactivateILRMaterialMap(params.row, true);
                }}>Active</button>

                <button type="button" style={{ width: "80%" }} className="btn btn-outline-danger btn-sm" 
                    disabled={!contributor ? true: params.row.active ? false : true}
                onClick={() => {
                    ActivateOrInactivateILRMaterialMap(params.row, false);
                }}>Inactive</button>
            </strong>
        )
    }

    const EditRow = (params) => {
        return (
            <strong>
                <button type="button" disabled= {!contributor ? true : false} className="btn btn-outline-primary btn-sm" onClick={() => {
                    openEditIlrMaterialMap(params.row);
                }}>Edit</button>
            </strong>
        )
    }

    var _column = [
        {
            field: 'site',
            headerName: 'Site',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'smProduct',
            headerName: 'SMProduct',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'sapMaterialGroup',
            headerName: 'SAP Material Group',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'mlpLevel',
            headerName: 'MLP Level',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'sampleTemplate',
            headerName: 'Sample Template',
            minwidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'active',
            headerName: 'Active',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'modifiedBy',
            headerName: 'Modified By',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'modifiedDate',
            headerName: 'ModifiedDate',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center'
        }
    ];

    // TODO: What roles should this column be visible for?
    // props.PostData.roleId != 2
    //if (contributor) {
        _column.push(
            {
                field: '-',
                headerName: 'Action(Edit)',
                width: 100,
                renderCell: EditRow,
                disableClickEventBubbling: true,
                headerAlign: 'center',
                align: 'center'

            });
            _column.push({
                field: '/',
                headerName: 'Action(Active/Inactive)',
                width: 220,
                renderCell: DeleteRow,
                disableClickEventBubbling: true,
                headerAlign: 'center',
                align: 'left'
            });
        //}

    var columns: GridColDef[] = _column;


    const openEditIlrMaterialMap = (params) => {
        setOpen(true);
        setSelectedValue(JSON.stringify(params).toString());
    };

    const openAddIlrMaterialMap = (params) => {
        setOpen(true);
        setSelectedValue("");
    };

    const handleFormClose = (response) => {
        if (response !== null && response === true) {
            LoadILRMaterialMapList();
        }
        setOpen(false);
    };

    const handleAlertClose = (response) => {
        AlertsetOpen(false);
    };

    const ActivateOrInactivateILRMaterialMap = async (rowData, isActive) => {

        const ILRMatrialMapFields = {
            ILRMaterialMapId: rowData.ilrMaterialMapId,
            ModifiedBy: username,
            Active: isActive
        };

        await fetchDataAuthenticated(_apiUrl + 'DeleteIlrMaterialMap', "POST", JSON.stringify(ILRMatrialMapFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadILRMaterialMapList();
                AlertsetOpen(false);
            })
            .catch(error => {
                AlertsetOpen(false);
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const LoadILRMaterialMapList = async () => {

        let params = new URLSearchParams();

        if (assignedSites && assignedSites.length > 0) {

            assignedSites.map(si => params.append("sites", si.siteName));

            await fetchDataAuthenticated(_apiUrl + "ilrMaterialMap?" + params.toString())
                .then(response => {
                    if (response.ok && response.status === 200) {
                        return response.json();
                    }
                    else if(response.status === 204)
                    {
                        return {};
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                })
                .catch(error => {
                    console.error(error);
                    setAlert("danger", "Error", error.message);
                });
        }
        else {
            console.error("In LoadILRMaterialMapList - You have no access to sites");
        }

    };

    const exportToExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('MaterialMap');
        worksheet.addRow(['Site','SmProduct','SapMaterialGroup','MlpLevel','SampleTemplate']);
        tableData.forEach(row => {
            worksheet.addRow([row.site,row.smProduct,row.sapMaterialGroup,row.mlpLevel,row.sampleTemplate])
        });
        workbook.xlsx.writeBuffer().then((buffer)=>
        {
            const blob = new Blob([buffer],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'MaterialMapDetails.xlsx';
            a.click();
        });

    };

    useEffect(() => {
        LoadILRMaterialMapList();
    }, [assignedSites]);

    if (!assignedSites) {
        return (
            <div className="d-flex justify-content-center">
                <p className="text-muted">You have no access to sites. Please contact your administrator.</p>
            </div>
        );
    }

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-6 titleBar'>
                    <img src={gridLogo} alt="grid logo" className="gridLogo" />
                    ILR Material Mapping
                </div>
                <div className='col-md-3'>
                    {/*TODO: implement this correctly: props.PostData.roleId != 2*/}
                    {<button type="button" disabled= {!contributor ? true : false} className="btn btn-outline-primary btn-primary-label" onClick={openAddIlrMaterialMap}>Add ILR Material Mapping</button>}
                </div>
                <div className='col-md-3'>
                    {<button type="button"  className="btn btn-outline-primary btn-primary-label" onClick={exportToExcel}>Export</button>}
                </div>
            </div>

            <Box sx={{ height: 375, width: '100%' }}>
                <DataGrid
                    rows={tableData}
                    columns={columns}
                    initialState={{
                        ...tableData.initialState,
                        pagination: { paginationModel: { pageSize: 20 } },
                      }}
                    pageSizeOptions={[20,50,100]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={(row: any) => row.ilrMaterialMapId}
                />
            </Box>

            <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="md">
                <DialogTitle className="csDialogTitle">ILR Material Mapping</DialogTitle>
                <ILRMaterialMapForm SelectedValueTochild={SelectedValue} PostData={props.PostData} CloseDialog={handleFormClose} />
            </Dialog>

            <Dialog
                open={Alertopen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to remove this item?
                    </DialogContentText>
                </DialogContent>
                <div className='container-fluid row mt-3 mb-3 '>
                    <div className='col-md-3'></div>
                    <div className='col-md-9 row'>
                        <div className='col-md-6'>
                            <button type="button" className="btn btn-outline-secondary  btn-sm" onClick={handleAlertClose}>Cancel</button>
                        </div>
                        <div className='col-md-6'>
                            <button type="button" className="btn btn-outline-danger  btn-sm" onClick={ActivateOrInactivateILRMaterialMap}>Delete</button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default ILRMaterialMapGrid;
